import axios from "axios";
import { FetchDataRequest, FetchDataResult } from "../../../Common/models/grid";
import { SieveResponse } from "../../../Common/models/sieve";
import {
    getSieveRequestModel,
    mapToFetchDataResult,
} from "../../../Common/utils/sieveRequestModel";

const DEFAULT_EXPORT_FILE_NAME = "paved-roads-projects.csv";

export const getPavedRoadsProjects = async (
  request: FetchDataRequest
): Promise<FetchDataResult> => {
  const sieveRequest = getSieveRequestModel(request);
  const { data } = await axios.get<SieveResponse>(
    `${window.configuration.apiUrl}api/Projects/paved-roads`,
    { params: sieveRequest }
  );

  return mapToFetchDataResult(data);
};

const getFileName = (contentDisposition?: string): string => {
  const match = contentDisposition?.match(/filename="?([^";]+)"?/);
  return match?.[1]?.trim() || DEFAULT_EXPORT_FILE_NAME;
};

export const exportPavedRoadsProjects = async (): Promise<void> => {
  const response = await axios.get<Blob>(
    `${window.configuration.apiUrl}api/Projects/paved-roads/export`,
    { responseType: "blob" }
  );

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute(
    "download",
    getFileName(response.headers["content-disposition"])
  );
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
